import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';

import Button from '@/components/Button';

import PickupsDownloadModal from './PickupsDownloadModal';
import usePickupsDownload from './usePickupsDownload';

interface PickupsDownloadButtonProps {
  trackingIds: string[];
}

const PickupsDownloadButton = ({ trackingIds }: PickupsDownloadButtonProps) => {
  const {
    isDownloadModalOpen,
    isDownloading,
    batchProgress,
    openDownloadModal,
    closeDownloadModal,
    downloadLabels,
  } = usePickupsDownload();

  return (
    <>
      <Button
        variant="contained"
        size="medium"
        startIcon={<CloudDownloadOutlinedIcon />}
        onClick={openDownloadModal}
        sx={{
          boxShadow: 'none',
          '&:focus': { boxShadow: 'none' },
          '&:active': { boxShadow: 'none' },
        }}
      >
        Descarga de etiquetas
      </Button>

      <PickupsDownloadModal
        isOpen={isDownloadModalOpen}
        isDownloading={isDownloading}
        batchProgress={batchProgress}
        trackingIds={trackingIds}
        onClose={closeDownloadModal}
        onDownload={downloadLabels}
      />
    </>
  );
};

export default PickupsDownloadButton;
